module.exports = __webpack_public_path__ + "img/massas.3959ff92.svg";